module.exports = __webpack_public_path__ + "img/device1.e075e20f.png";